import type { SelectOptionType } from '@bp/ui-components';

function getGrades() {
  return Array(14)
    .fill(1)
    .map((_, index) => index.toString());
}

function getGradeOptions(): SelectOptionType[] {
  return getGrades().map((g) => {
    return { value: g, label: g };
  });
}

function getGradeAndGradeGroupFromString(value: string): { grade: number; gradeGroup: string } {
  // remove extra whitespace and normalize the string
  const normalized = value.toString().trim();

  // extract number and string parts using regex
  const numberMatch = normalized.match(/\d+/);
  const letterMatch = normalized.match(/[A-Za-z]+/);

  const grade = numberMatch ? parseInt(numberMatch[0], 10) : 0;
  const gradeGroup = letterMatch ? letterMatch[0] : '';

  return {
    grade,
    gradeGroup,
  };
}

export { getGrades, getGradeOptions, getGradeAndGradeGroupFromString };
